import { render, staticRenderFns } from "./ContratsItem.vue?vue&type=template&id=64caefd3&"
import script from "./ContratsItem.vue?vue&type=script&lang=js&"
export * from "./ContratsItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports